import { Injectable } from '@angular/core';
import { AbstractService } from './abstract.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CreateLeadDto } from '../dto/create-lead.dto';

@Injectable({
   providedIn: 'root'
})
export class LeadService extends AbstractService {
   constructor(http: HttpClient) {
      super(http);
   }

   async createLeadWhatsapp(property_code: string, finality: number) {
      const url = this.API_REST + '/lead-whatsapp';
      const response$ = this.http.post<boolean>(url, { property_code, finality }, {});

      return await firstValueFrom(response$);
   }

   async createLead(lead: CreateLeadDto) {
      const url = this.API_REST + '/lead';
      const response$ = this.http.post<boolean>(url, lead, {});

      return await firstValueFrom(response$);
   }

   async createLeadLais(lead: CreateLeadDto) {
      const url = this.API_REST + '/lead-lais';
      const response$ = this.http.post<boolean>(url, lead, {});

      return await firstValueFrom(response$);
   }
}
